
// ドロップダウンの位置が親にかぶらないように
// ドロップダウンの幅が親の幅に揃うように

import {merge} from 'lodash-es'
import {QSelect} from 'quasar'

export default {
  ...QSelect,

  render(h) {
    const createElement = (components, options, children) => {
      if(typeof components === 'object' && components.name === 'QPopover') {
        options = merge({}, options, {
          props: {
            cover: false,
            fit: true,
          },
        })
      }
      return h(components, options, children)
    }
    return QSelect.render.bind(this)(createElement)
  },
}
